import {
  Outlet,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom-v5-compat'

import { BufferTrackerReact } from '@buffer-mono/tracking-plan'

import { useOrganizationId } from '~publish/contexts/AccountContext/hooks'
import { useOnce } from '~publish/hooks/useOnce'
import { createTemplates } from '~publish/legacy/routes'

import { TemplateDialog } from './TemplateDialog'
import { useTemplates } from '../../hooks/useTemplates'

const isCta = (cta: string | null | undefined): cta is CTA => {
  if (!cta) {
    return false
  }
  return (
    (cta.startsWith('create-') ||
      cta.startsWith('publish-') ||
      cta.startsWith('community-')) &&
    cta.split('-').length === 5 &&
    cta[cta.length - 1].match(/^\d+$/) !== null
  )
}

type TemplateDialogParams = {
  templateId: string
}

export const TemplateDialogRoute = (): JSX.Element | null => {
  const navigate = useNavigate()
  const { templateId } = useParams<TemplateDialogParams>()
  const [searchParams] = useSearchParams()
  const ctaParam = searchParams.get('cta')
  const cta = isCta(ctaParam) ? ctaParam : 'create-templates-dialog-deepLink-1'
  const preselectChannelId = searchParams.get('preselectChannelId') ?? undefined

  const { templates } = useTemplates()
  const template = templates.find((t) => t.id === templateId)

  const organizationId = useOrganizationId()

  useOnce(() => {
    if (templateId && organizationId) {
      BufferTrackerReact.templateClicked({
        cta,
        organizationId: organizationId ?? '',
        product: 'publish',
        templateId,
      })
      return true
    }
    return false
  }, [organizationId, templateId, cta])

  const onClose = (open: boolean): void => {
    if (!open) {
      navigate(createTemplates.route)
    }
  }

  if (!template) {
    return null
  }

  return (
    <>
      <Outlet />
      <TemplateDialog
        template={template}
        cta={cta}
        preselectChannelId={preselectChannelId}
        open={true}
        onOpenChange={onClose}
      />
    </>
  )
}
